import { useState, useEffect } from "react";

import slider1 from "../assets/Resim11.png";
import slider2 from "../assets/Resim12.png";
// import slider3 from "../assets/Resim14.png";
import slider5 from "../assets/Resim16.png";
import slider6 from "../assets/Resim17.png";
import slider7 from "../assets/Resim18.png";
import slider8 from "../assets/Resim19.png";
import slider9 from "../assets/Resim20.png";
import slider11 from "../assets/Resim22.png";
import slider12 from "../assets/Resim23.png";
import slider13 from "../assets/Resim24.png";
import slider14 from "../assets/Resim25.png";
import slider15 from "../assets/24521-VS-A-03.jpg";
import slider16 from "../assets/24521-VS-A-05.jpg";
import slider17 from "../assets/24521-VS-A-04.jpg";

import indicator1 from "../assets/calistay.PNG";
import indicator2 from "../assets/msi.PNG";
import indicator3 from "../assets/mimari_tasarim.PNG";

const images = [
  slider13,
  slider14,
  slider15,
  slider17,
  slider16
];

const indicators_images = [
  indicator1,
  indicator2,
  indicator3
];

export const Card = ({ alt, src, title, onOpen }) => {
    return (
      <div className="card">
        <img src={src} className="card-img-top px-4 pt-4 pb-3" alt={alt} />
        <div className="card-body d-flex flex-column px-4 pb-4 pt-0">
          <h5 className="card-title">{title}</h5>
          <p className="card-text btn-card-detail mt-auto pt-1 me-1" role="button" onClick={onOpen}>
            <i class="bi bi-chevron-double-right"></i>
          </p>
        </div>
      </div>
    );
};

export const Modal = ({ show, title, description, onClose }) => {
  
  // Body scroll kilitleme
  useEffect(() => {
    if (show) {
      document.body.classList.add("modal-open");
      document.body.style.overflow = "hidden";
    } else {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
    }
  }, [show]);

  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" onClick={onClose}>
        <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">

            <div className="modal-header header-hero">
              <h4 className="modal-title">{title}</h4>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>

            <div className="modal-body">
              {description}
            </div>

          </div>
        </div>
      </div>

      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

// export const Card = ({ unique, alt, src, title, description }) => {
//     return (
//       <div key={`card-key-${unique}`} className="card">
//         <img src={src} className="card-img-top px-4 pt-4 pb-3" alt={alt} />
//         <div className="card-body px-4 pb-4 pt-0">
//           <h5 className="card-title">{title}</h5>
//           <span type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target={`#modal-${unique}`}>
//   Launch demo modal
// </span>
//         </div>
//       </div>
//     );
// };

// export const Modal = ({ unique, title, description }) => {
//   return (
//     <div className="modal fade" id={`modal-${unique}`} tabIndex="-1" aria-labelledby={`modalLabel-${unique}`} aria-hidden="true">
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content">
//           <div className="modal-header">
//             <h5 className="modal-title" id={`modalLabel-${unique}`}>{title}</h5>
//             <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
//           </div>
//           <div className="modal-body">
//             {description}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

export const Carousel = () => {
  const [current, setCurrent] = useState(0);

  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setCurrent((prev) => (prev + 1) % images.length);
  //   }, 3000);

  //   return () => clearInterval(timer);
  // }, []);

  return (
    <div id="carouselExampleSlidesOnly" className="carousel slide carousel-fade" data-bs-ride="carousel">
      <div className="carousel-inner">
        {images.map((img, index) => (
          <div
            key={`slide-${index}`}
            className={`carousel-item ${index === current ? "active" : ""}`}
            data-bs-interval="2000"
          >
            <img
              src={img}
              className="d-block w-100"
              alt={`slide-${index}`}
            />
          </div>
        ))}
      </div>

      {/* Opsiyonel: Slider kontrolleri */}
      {/* <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExample"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExample"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button> */}
    </div>
  );
};

export const CarouselIndicators = () => {
  const [currentIndicator, setCurrentIndicator] = useState(0);

  return (
    <div id="carouselExampleIndicators" className="carousel slide anasayfa-indicator pt-4" data-bs-ride="carousel">
      <div className="carousel-inner">
        {indicators_images.map((image, indexImage) => (
          <div
            key={`indicator-${indexImage}`}
            className={`carousel-item ${indexImage === currentIndicator ? "active" : ""}`}
          >
            <img
              src={image}
              className="d-block"
              alt={`indicator-${indexImage}`}
            />
          </div>
        ))}
      </div>

      <div className="carousel-indicators">
        {indicators_images.map((_, indexIndicator) => (
          <button 
            key={`indicator-${indexIndicator}`}
            type="button" 
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to={indexIndicator}
            className={indexIndicator === currentIndicator ? "active" : ""}
            onClick={() => setCurrentIndicator(indexIndicator)}
          ></button>
        ))}
      </div>

    </div>
  );
}
